import { ElementType } from 'react';

import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';

interface BulkOpTagProps {
  label: string;
  icon?: ElementType;
  onDelete?: () => void;
}

export default function BulkOpTag({
  label,
  icon: Icon,
  onDelete,
}: BulkOpTagProps) {
  const theme = useTheme();
  const tags = theme.palette.semantic.tags;
  return (
    <Chip
      size="small"
      label={label}
      onDelete={onDelete}
      avatar={
        Icon ? (
          <Avatar sx={{ backgroundColor: tags.iconBg }}>
            <Icon sx={{ fontSize: 12, color: tags.icon }} />
          </Avatar>
        ) : undefined
      }
      sx={{
        width: 'fit-content',
        backgroundColor: tags.default,
        color: theme.palette.semantic.text.title2,
        border: '0.5px solid',
        borderColor: tags.border,
        // Design: 2px inset, 20px avatar, 16px delete icon.
        '& .MuiChip-avatar': { width: 20, height: 20, ml: '2px', mr: 0 },
        '& .MuiChip-deleteIcon': {
          color: tags.iconBg,
          fontSize: 16,
          m: '0 4px 0 -4px',
        },
      }}
    />
  );
}
